export const getToken = () => {
  return localStorage.getItem('token');
};

export const getSession = () => {
  return localStorage.getItem('session');
};
